import { Button, ThemeProvider } from '@mui/material'
import { Link } from 'react-router-dom'
import { useScreenSize } from '../../hooks/useScreenSize'
import { useStoreState } from '../../store/hooks'
import theme from '../../theme/theme-v2'
import { MissionsIcon } from './assets/MissionsIcon'

export const RewardButton = () => {
    const { isMobile } = useScreenSize()
    const isCompletedChallenges = useStoreState((state) => state.rewardsService.isCompletedChallenges)

    return (
        <ThemeProvider theme={theme}>
            <Link to="/profile/missions">
                {isMobile ? (
                    <Button
                        animated={Boolean(isCompletedChallenges)}
                        badge={isCompletedChallenges}
                        endIcon={<MissionsIcon />}
                        color="secondary"
                        size="large"
                        variant="contained"
                        onlyIcon
                    />
                ) : (
                    <Button
                        animated={Boolean(isCompletedChallenges)}
                        badge={isCompletedChallenges}
                        endIcon={<MissionsIcon />}
                        color="secondary"
                        variant="contained"
                    >
                        Missions
                    </Button>
                )}
            </Link>
        </ThemeProvider>
    )
}
